var wipwrp = window.wipwrp || {};

wipwrp.anagraficaAssociata = (function($,mzr,doc,win) {

    var self = {};

    self.init = function () {
        _bindAnagraficaAssociata();
    }

    function _bindAnagraficaAssociata() {
        $('#anagrafica-associata').on('submit', function (e) {
            e.preventDefault();
            var form = $(this);

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: form.serialize(),
                success: function (response) {
                    $('button[type=submit]', $('#anagrafica-associata')).remove();
                    $('#anagrafica-associata-sent').show();
                },
                error: function (xhr, status, error) {
                    vex.dialog.alert({
                        message: 'Si è verificato un errore durante l\'invio della richista. Riprova più tardi.',
                        showCloseButton: true,
                        overlayClosesOnClick: false,
                        buttons: [],
                    });
                }
            });
        });
    }

    return self;
})(jQuery,Modernizr, document, window);